var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivacyPolicymassagenoti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5007 1.66797H5.00065C4.55862 1.66797 4.1347 1.84356 3.82214 2.15612C3.50958 2.46868 3.33398 2.89261 3.33398 3.33464V16.668C3.33398 17.11 3.50958 17.5339 3.82214 17.8465C4.1347 18.159 4.55862 18.3346 5.00065 18.3346H15.0007C15.4427 18.3346 15.8666 18.159 16.1792 17.8465C16.4917 17.5339 16.6673 17.11 16.6673 16.668V5.83464C15.0401 4.20745 14.1278 3.29515 12.5007 1.66797Z",
    stroke: "#4B5563",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 1.66797V5.0013C11.666 5.44333 11.8416 5.86725 12.1542 6.17981C12.4667 6.49237 12.8907 6.66797 13.3327 6.66797H16.666",
    stroke: "#4B5563",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33268 7.5H6.66602",
    stroke: "#4B5563",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 10.832H6.66602",
    stroke: "#4B5563",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 14.168H6.66602",
    stroke: "#4B5563",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicymassagenoti);
export default __webpack_public_path__ + "static/media/Privacy Policy massage noti.24871ac60bbe675ec9df101365f85b87.svg";
export { ForwardRef as ReactComponent };